/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  LoginIn,
  MeOut,
  MeUpdate,
  ProblemDetail
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Login
 */
export const authLogin = (
    loginIn: BodyType<LoginIn>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<MeOut>(
      {url: `/api/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginIn, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getAuthLoginMutationOptions = <TError = ErrorType<ProblemDetail | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: BodyType<LoginIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: BodyType<LoginIn>}, TContext> => {

const mutationKey = ['authLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogin>>, {data: BodyType<LoginIn>}> = (props) => {
          const {data} = props ?? {};

          return  authLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authLogin>>>
    export type AuthLoginMutationBody = BodyType<LoginIn>
    export type AuthLoginMutationError = ErrorType<ProblemDetail | HTTPValidationError>

    /**
 * @summary Login
 */
export const useAuthLogin = <TError = ErrorType<ProblemDetail | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: BodyType<LoginIn>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogin>>,
        TError,
        {data: BodyType<LoginIn>},
        TContext
      > => {

      const mutationOptions = getAuthLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Публичный и идемпотентный: истёкшая сессия тоже должна уметь «выйти» и очистить cookie.
 * @summary Logout
 */
export const authLogout = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<void>(
      {url: `/api/v1/auth/logout`, method: 'POST', ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getAuthLogoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,void, TContext> => {

const mutationKey = ['authLogout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogout>>, void> = () => {
          

          return  authLogout(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof authLogout>>>
    
    export type AuthLogoutMutationError = ErrorType<unknown>

    /**
 * @summary Logout
 */
export const useAuthLogout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAuthLogoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Me
 */
export const authMe = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<MeOut>(
      {url: `/api/v1/auth/me`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getAuthMeQueryKey = () => {
    return [
    `/api/v1/auth/me`
    ] as const;
    }

    
export const getAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorType<ProblemDetail>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authMe>>> = ({ signal }) => authMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof authMe>>>
export type AuthMeQueryError = ErrorType<ProblemDetail>


export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorType<ProblemDetail>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Me
 */

export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Настройки текущего пользователя: язык интерфейса
 */
export const authUpdateMe = (
    meUpdate: BodyType<MeUpdate>,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<MeOut>(
      {url: `/api/v1/auth/me`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: meUpdate
    },
      options);
    }
  


export const getAuthUpdateMeMutationOptions = <TError = ErrorType<ProblemDetail | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError,{data: BodyType<MeUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError,{data: BodyType<MeUpdate>}, TContext> => {

const mutationKey = ['authUpdateMe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUpdateMe>>, {data: BodyType<MeUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  authUpdateMe(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthUpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof authUpdateMe>>>
    export type AuthUpdateMeMutationBody = BodyType<MeUpdate>
    export type AuthUpdateMeMutationError = ErrorType<ProblemDetail | HTTPValidationError>

    /**
 * @summary Настройки текущего пользователя: язык интерфейса
 */
export const useAuthUpdateMe = <TError = ErrorType<ProblemDetail | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError,{data: BodyType<MeUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUpdateMe>>,
        TError,
        {data: BodyType<MeUpdate>},
        TContext
      > => {

      const mutationOptions = getAuthUpdateMeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    